import { render, staticRenderFns } from "./ChooseBankMulti.vue?vue&type=template&id=0fd837c4&scoped=true"
import script from "./ChooseBankMulti.vue?vue&type=script&lang=js"
export * from "./ChooseBankMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd837c4",
  null
  
)

export default component.exports